import { render, staticRenderFns } from "./BuddyBotAPI.vue?vue&type=template&id=bfab9690&scoped=true"
import script from "./BuddyBotAPI.vue?vue&type=script&lang=js"
export * from "./BuddyBotAPI.vue?vue&type=script&lang=js"
import style0 from "./BuddyBotAPI.vue?vue&type=style&index=0&id=bfab9690&prod&lang=css"
import style1 from "./BuddyBotAPI.vue?vue&type=style&index=1&id=bfab9690&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfab9690",
  null
  
)

export default component.exports